import { CardSvg } from '@/play/cardSvg'

/** Home card art for Oozery: a cream bowl with neon goo poured into it (no text). */
export function OozeryCardArt() {
  return (
    <CardSvg bg="#f3efe8">
      {/* table and bowl */}
      <rect x="0" y="150" width="320" height="50" fill="#d9ccb9" />
      <ellipse cx="160" cy="150" rx="118" ry="28" fill="#e8dccb" />
      <path d="M42 150 A 118 28 0 0 0 278 150 L 266 118 A 106 20 0 0 1 54 118 Z" fill="#e8dccb" />
      <ellipse cx="160" cy="118" rx="106" ry="20" fill="#f6efe4" />
      {/* the goo pooled in the bowl */}
      <ellipse cx="160" cy="121" rx="70" ry="12" fill="#6dff3a" />
      <ellipse cx="190" cy="119" rx="30" ry="8" fill="#ff3fb4" />
      {/* a rope of goo pouring in */}
      <path d="M150 0 C 150 40, 160 60, 158 110" stroke="#2ef2ff" strokeWidth="14" strokeLinecap="round" fill="none" />
      <ellipse cx="158" cy="114" rx="22" ry="7" fill="#2ef2ff" />
      <path d="M146 18 C 146 40, 150 60, 149 90" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.55" />
    </CardSvg>
  )
}
